module.exports = __webpack_public_path__ + "img/uj_02.37377b78.jpg";